import { render, staticRenderFns } from "./DialogAboutThisContent.vue?vue&type=template&id=f9fd9ef8&scoped=true&"
var script = {}
import style0 from "./DialogAboutThisContent.vue?vue&type=style&index=0&id=f9fd9ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fd9ef8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
